module.exports = __webpack_public_path__ + "static/img/9.a28aa808.png";